import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800 transition-colors mb-8">
        <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
      </Link>

      <h1 className="text-3xl font-outfit font-extrabold text-slate-900 mb-2">Datenschutzerklärung</h1>
      <p className="text-slate-400 text-sm mb-10">Stand: Juni 2026 · Gilt ab sofort</p>

      <div className="space-y-8 text-slate-700 text-sm leading-relaxed">

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">1. Über diese Datenschutzerklärung</h2>
          <p>
            Diese Datenschutzerklärung gilt für alle personenbezogenen Daten, die dealzauber.de von Dir oder über Dich
            speichert, wenn Du unsere Plattform besuchst oder unsere Dienste nutzt. Wir erläutern, warum und wie wir
            Deine persönlichen Daten verarbeiten.
          </p>
          <p className="mt-3">
            <strong>Verantwortlicher im Sinne der DSGVO:</strong><br />
            Kenan Artiran & Mustafa Emirler<br />
            Parksiedlung Spruch 86, 12349 Berlin<br />
            E-Mail: <a href="mailto:admin@dealzauber.de" className="text-[#A259FF] hover:underline">admin@dealzauber.de</a>
          </p>
          <p className="mt-3">
            Wir können diese Datenschutzerklärung jederzeit anpassen und werden Dich innerhalb eines angemessenen
            Zeitraums vor dem Inkrafttreten einer neuen Version informieren.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">2. Welche Daten verarbeiten wir?</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-slate-50">
                  <th className="text-left p-3 border border-slate-200 font-semibold text-slate-700">Datenkategorie</th>
                  <th className="text-left p-3 border border-slate-200 font-semibold text-slate-700">Beispiele</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-3 border border-slate-200"><strong>Pflichtangaben bei Registrierung</strong></td>
                  <td className="p-3 border border-slate-200">E-Mail-Adresse, Benutzername, Passwort (verschlüsselt)</td>
                </tr>
                <tr className="bg-slate-50/50">
                  <td className="p-3 border border-slate-200"><strong>Freiwillige Angaben</strong></td>
                  <td className="p-3 border border-slate-200">Profilname, eingereichte Deals, Kommentare, Abstimmungen</td>
                </tr>
                <tr>
                  <td className="p-3 border border-slate-200"><strong>Automatisch erfasste Daten</strong></td>
                  <td className="p-3 border border-slate-200">IP-Adresse, Datum/Uhrzeit, Browser, Betriebssystem, besuchte Seiten</td>
                </tr>
                <tr className="bg-slate-50/50">
                  <td className="p-3 border border-slate-200"><strong>Technische Speicherung</strong></td>
                  <td className="p-3 border border-slate-200">Login-Token (localStorage), anonyme Voter-ID (localStorage)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">3. Warum und wofür nutzen wir Deine Daten?</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-slate-50">
                  <th className="text-left p-3 border border-slate-200 font-semibold text-slate-700">Zweck</th>
                  <th className="text-left p-3 border border-slate-200 font-semibold text-slate-700">Rechtsgrundlage</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-3 border border-slate-200">Registrierung und Anmeldung</td>
                  <td className="p-3 border border-slate-200">Vertragliche Notwendigkeit (Art. 6 Abs. 1 lit. b DSGVO)</td>
                </tr>
                <tr className="bg-slate-50/50">
                  <td className="p-3 border border-slate-200">Bereitstellung der Plattform-Dienste</td>
                  <td className="p-3 border border-slate-200">Vertragliche Notwendigkeit</td>
                </tr>
                <tr>
                  <td className="p-3 border border-slate-200">Missbrauchsprävention und Sicherheit</td>
                  <td className="p-3 border border-slate-200">Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO)</td>
                </tr>
                <tr className="bg-slate-50/50">
                  <td className="p-3 border border-slate-200">Verbesserung der Plattform</td>
                  <td className="p-3 border border-slate-200">Berechtigtes Interesse</td>
                </tr>
                <tr>
                  <td className="p-3 border border-slate-200">Einhaltung gesetzlicher Pflichten</td>
                  <td className="p-3 border border-slate-200">Rechtliche Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO)</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">4. Wie lange speichern wir Deine Daten?</h2>
          <p>
            Wir speichern Deine personenbezogenen Daten so lange, wie es für den jeweiligen Zweck erforderlich ist —
            insbesondere solange Du unsere Dienste nutzt und für einen Zeitraum von 3 Jahren nach der letzten Nutzung.
          </p>
          <p className="mt-2">
            Wenn Dein Konto gelöscht wird, werden Deine Profildaten entfernt. Deine Beiträge, Deals und Kommentare
            bleiben anonymisiert gespeichert, um die Integrität der Community zu wahren.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">5. Cookies und lokale Speicherung</h2>
          <p>Wir nutzen ausschließlich technisch notwendige Speicherung im Browser:</p>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li><strong>Authentifizierungstoken</strong> — hält Dich eingeloggt (localStorage)</li>
            <li><strong>Anonyme Voter-ID</strong> — ermöglicht Deal-Abstimmung ohne Registrierung (localStorage)</li>
          </ul>
          <p className="mt-2 text-slate-500">
            Wir setzen <strong>keine Tracking-Cookies</strong>, keine Werbe-Cookies und keine Analyse-Cookies von Drittanbietern ein.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">6. Affiliate-Links & externe Anbieter</h2>
          <p>
            dealzauber.de enthält Affiliate-Links zu externen Händlern (z. B. Amazon, Awin-Partner). Wenn Du über
            diese Links einkaufst, erhalten wir eine Provision. Dabei können durch den jeweiligen Händler eigene
            Cookies gesetzt werden. Auf diese haben wir keinen Einfluss — bitte lies die Datenschutzerklärung des
            jeweiligen Anbieters.
          </p>
          <p className="mt-2">
            Ob wir eine Provision erhalten oder nicht, hat <strong>keinen Einfluss</strong> auf die Bewertung oder
            Platzierung eines Deals. Die Temperatur wird ausschließlich von der Community bestimmt.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">7. Weitergabe an Dritte</h2>
          <p>
            Wir <strong>verkaufen keine personenbezogenen Daten</strong> an Dritte.
            Eine Übermittlung erfolgt nur, wenn wir gesetzlich dazu verpflichtet sind.
          </p>
          <p className="mt-2">
            Wir nutzen KI-Dienste (DeepSeek) ausschließlich für interne Zwecke (Deal-Bewertung, Content-Erstellung).
            Nutzerdaten werden dabei nicht übermittelt.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">8. Datenspeicherung & Sicherheit</h2>
          <p>
            Unsere Server befinden sich in der EU (Helsinki, Finnland, Hetzner Online GmbH).
            Alle Verbindungen sind SSL/TLS-verschlüsselt (HTTPS). Passwörter werden ausschließlich
            als bcrypt-Hash gespeichert — wir kennen Dein Passwort nicht.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">9. Deine Rechte (DSGVO)</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr className="bg-slate-50">
                  <th className="text-left p-3 border border-slate-200 font-semibold text-slate-700">Recht</th>
                  <th className="text-left p-3 border border-slate-200 font-semibold text-slate-700">Was bedeutet das?</th>
                </tr>
              </thead>
              <tbody>
                <tr><td className="p-3 border border-slate-200">Auskunft (Art. 15)</td><td className="p-3 border border-slate-200">Du kannst eine Kopie Deiner gespeicherten Daten anfordern</td></tr>
                <tr className="bg-slate-50/50"><td className="p-3 border border-slate-200">Berichtigung (Art. 16)</td><td className="p-3 border border-slate-200">Du kannst falsche Daten korrigieren lassen</td></tr>
                <tr><td className="p-3 border border-slate-200">Löschung (Art. 17)</td><td className="p-3 border border-slate-200">Du kannst die Löschung Deines Kontos und Deiner Daten verlangen</td></tr>
                <tr className="bg-slate-50/50"><td className="p-3 border border-slate-200">Einschränkung (Art. 18)</td><td className="p-3 border border-slate-200">Du kannst die Verarbeitung Deiner Daten einschränken lassen</td></tr>
                <tr><td className="p-3 border border-slate-200">Datenübertragbarkeit (Art. 20)</td><td className="p-3 border border-slate-200">Du kannst Deine Daten in maschinenlesbarem Format erhalten</td></tr>
                <tr className="bg-slate-50/50"><td className="p-3 border border-slate-200">Widerspruch (Art. 21)</td><td className="p-3 border border-slate-200">Du kannst der Verarbeitung Deiner Daten widersprechen</td></tr>
              </tbody>
            </table>
          </div>
          <p className="mt-4">
            Zur Ausübung Deiner Rechte schreib uns an:{" "}
            <a href="mailto:admin@dealzauber.de" className="text-[#A259FF] hover:underline">admin@dealzauber.de</a>
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">10. Beschwerderecht</h2>
          <p>
            Du hast das Recht, Dich bei der zuständigen Datenschutzaufsichtsbehörde zu beschweren:
          </p>
          <p className="mt-2">
            <strong>Berliner Beauftragte für Datenschutz und Informationsfreiheit</strong><br />
            Alt-Moabit 59–61, 10555 Berlin<br />
            E-Mail: <a href="mailto:mailbox@datenschutz-berlin.de" className="text-[#A259FF] hover:underline">mailbox@datenschutz-berlin.de</a><br />
            Web: <a href="https://www.datenschutz-berlin.de" target="_blank" rel="noopener noreferrer" className="text-[#A259FF] hover:underline">www.datenschutz-berlin.de</a>
          </p>
        </section>

      </div>
    </div>
  );
}
